export interface FormatNumberOptions {
  digits: number
}
export const formatNumber = (num: number, options: FormatNumberOptions = { digits: 2 }) =>
  (Math.round(num * 100) / 100).toFixed(options.digits)
